import { render, staticRenderFns } from "./VKFreeCourse.vue?vue&type=template&id=d9519232&lang=pug&"
import script from "./VKFreeCourse.vue?vue&type=script&lang=ts&"
export * from "./VKFreeCourse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports